/**
 */
export interface RecoveryConfig {
    /** Similarity (see `TextSimilarity`) a candidate paragraph must reach against the last anchored text. */
    candidateSimilarity: number;
    /** Two candidates closer than this are a tie, reported as ambiguous. */
    candidateMargin: number;
    /** A lost redline retries recovery on the heartbeat at most this often. */
    heartbeatMs: number;
    /** Neighbouring paragraphs remembered per tracker; enough to survive several edits around the redline. */
    neighbourMemory: number;
    /** Word's `Range.search` rejects long needles; anchor words are cut to this many characters. */
    searchLimit: number;
    /** Paragraph ids the change ledger keeps; the oldest are evicted beyond this. */
    ledgerLimit: number;
    /** Recovery attempts kept for the UI and the anchor log. */
    attemptHistory: number;
    /** Recently changed paragraphs handed to the server resolver as hints for the LLM. */
    serverCandidateLimit: number;
}

/**
 * VALUE
 *   Default RecoveryConfig values used unless a test or caller overrides them.
 */
export const DEFAULT_RECOVERY_CONFIG: RecoveryConfig = {
    /**
     * VALUE
     *   0.75
     */
    candidateSimilarity: 0.75,
    /**
     * VALUE
     *   0.1
     */
    candidateMargin: 0.1,
    /**
     * VALUE
     *   60_000 ms = 1 minute
     */
    heartbeatMs: 60_000,
    /**
     * VALUE
     *   8 neighbouring paragraphs
     */
    neighbourMemory: 8,
    /**
     * VALUE
     *   200 characters
     */
    searchLimit: 200,
    /**
     * VALUE
     *   500 paragraph ids
     */
    ledgerLimit: 500,
    /**
     * VALUE
     *   20 recovery attempts
     */
    attemptHistory: 20,
    /**
     * VALUE
     *   12 recent paragraphs
     */
    serverCandidateLimit: 12,
/**
 * SCOPE
 *   RecoveryConfig holds the tracker's tunable values.
 *   Tracker behaviour lives in code; tests and the add-in vary only these numbers.
 */
};
